// extracted by mini-css-extract-plugin
module.exports = {"button":"Banner_button__fkdXo","sparkle":"Banner_sparkle__l98iH","activityCard":"Banner_activityCard__Orxr5"};